import type { Option } from '@/screens/scan/lib/options'

/** Segmented button group — mirrors the web app's "Is Archived" control. */
export function Segmented({
  options,
  value,
  onChange,
  className
}: {
  options: Option[]
  value: string
  onChange: (value: string) => void
  className?: string
}) {
  return (
    <div className={`ramp-seg${className ? ` ${className}` : ''}`} role='group'>
      {options.map((option) => (
        <button
          key={option.value}
          type='button'
          className={`ramp-seg-btn${value === option.value ? ' is-active' : ''}`}
          aria-pressed={value === option.value}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  )
}
